import { INE_URL } from 'constants/domains';

export const toolbarMenuItems = [
  {
    text: 'Learning Platform',
    href: `${INE_URL}`,
    openInNewTab: true,
  },
  {
    text: 'Business Platform Video Tutorials',
    href: `${INE_URL}/course/ine-business-platform-essentials/e934aced-c3a6-4dab-8e47-0b468eabf401?hsCtaAttrib=187923358284`,
    openInNewTab: true,
  },
  {
    text: 'Troubleshooting and FAQs',
    href: `${INE_URL}/troubleshooting`,
    openInNewTab: true,
  },
];

export const notifications = [
  {
    name: 'Brad Simmons',
    ago: '2 min ago',
    message: 'Joined your team Marketing',
    isOnline: true,
  },
  {
    name: 'Amanda Stanberry',
    ago: '27 min ago',
    message: 'Passed Pentration Testing Student quiz',
    isOnline: false,
  },
];
